import axios from 'axios';
import { useQuery } from 'react-query';

export interface EventSettings {
  eventid: number;
  type: string;
  status: string;
  message: string;
  name: string;
  code: string;
  actual: string;
  timezone: string;
  allowtexting: boolean;
  textprefix: string;
  allowpaymentoffees: boolean;
  defaultpaymentoffees: boolean;
  billme: boolean;
  allowattendedbytickettype: boolean;
  ccfee: number;
  logourl: string;
  eventprivacy: string;
  storeheader: string;
  storebuttonevent: string;
  storebuttoneventshow: boolean;
  storebuttonauction: string;
  storebuttonauctionshow: boolean;

  storebuttondonate: string;
  storebuttondonateshow: boolean;
  storefooter: string;
  active: boolean;
}

const defaultEventSettings = {
  type: "",
  status: "",
  message: "",
  eventid: 0,
  name: "",
  code: "",
  actual: "",
  timezone: "",
  allowtexting: false,
  textprefix: "",
  allowpaymentoffees: false,
  defaultpaymentoffees: false,
  billme: false,
  allowattendedbytickettype: false,
  ccfee: 0,
  logourl: "",
  eventprivacy: "",
  storeheader: "",
  storebuttonevent: "",
  storebuttoneventshow: false,
  storebuttonauction: "",
  storebuttonauctionshow: false,
  storebuttondonate: "",
  storebuttondonateshow: false,
  storefooter: "",
  active: false
}

export const globalEventSettingsFetcher = async (eventIdvalue) => {
  const json = JSON.stringify({ eventid: eventIdvalue })
  const { data } = await axios.post('/evtsettings', json, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
  const parsedData = JSON.parse(data.jsonString)
  return parsedData as EventSettings
}

export const useFetchEventSettings = (eventid) => {
  return useQuery<EventSettings>(
    ['/evtsettings', eventid],
    () => globalEventSettingsFetcher(eventid),
  )
}
